<script lang="typescript">
    import { createEventDispatcher } from "svelte";

    const dispatch = createEventDispatcher();

    export let selected: any = undefined;
    let iSelected = selected;

    export let items: any[] = [
        {
            title: "Title",
            subtitle: "subtitle",
        },
    ];
    let iItems = items;

    $: {
        iSelected = selected;
        iItems = items;
    }

    export const i: string = "";
    const onSelect = (item: any) => {
        dispatch("select", { selected: item });
    };
</script>

<ul class="list">
    {#each iItems as item, index (index)}
        <li
            class="list-item"
            class:active={item == iSelected}
            on:click={() => onSelect(item)}
        >
            <slot
                name="item"
                {item}
                {index}
                active={item == iSelected}
                
            />
        </li>
    {/each}
</ul>

<style>
    :root {
        --list-active: rgba(var(--color-primary-value), 0.1);
    }
    .list {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .list-item {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        height: 56px;
        width: 100%;
        align-items: center;
        cursor: pointer;
    }

    .active {
        background-color: var(--list-active, rgba(187, 134, 252, 0.3));
    }

    .list-item:hover {
        background-color: var(--color-level-2);
    }
</style>
